module.exports = __webpack_public_path__ + "media/tase/icoImportant-927e4ddf.webp";